<div style="margin: 16px;" class="mat-typography">
  <div class="message" [innerHTML]="sponsorshipMessage"></div>
</div>